module.exports = __webpack_public_path__ + "static/media/hero-bg.cf30d881.png";